import { render } from "./SVGTshirt.vue?vue&type=template&id=31845125"
import script from "./SVGTshirt.vue?vue&type=script&lang=js"
export * from "./SVGTshirt.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__